import store from '@/store/index'

class ToastController {
    constructor() {}

    showToast(text) {
        store.dispatch('setToast', {
            isShow: true,
            text: text
        })
    }
}


const TC = new ToastController()
export default TC